<template>
    <form
        @submit.prevent="onSubmitForm"
        autocomplete="off"
    >

      <CRow>
        <CCol sm="12">
          <CTextarea
            label="Comment"
            placeholder="Enter comment"
            v-model="formData.comment"
            rows="7"
            required
          />
        </CCol>
      </CRow>

      <CRow>
        <CCol col="auto">
          <CButton
            type="submit"
            color="outline-primary"
          >Save</CButton>
        </CCol>
      </CRow>
    </form>
</template>
<script>
import {
  createCommentsStoreMixin,
  commentsStore
} from '@/mixins/commentsMixin'
export default {
  name: 'VCommentForm',

  mixins: [
    createCommentsStoreMixin()
  ],

  props: {
    comment: {
      type: Object
    }
  },

  data: () => ({
    formData: {
      comment: ''
    }
  }),

  watch: {
    comment () {
      this.initData()
    }
  },

  methods: {
    initData () {
      if (this.comment) {
        this.formData = {
          comment: this.comment.comment
        }
      } else {
        this.formData = {
          comment: ''
        }
      }
    },

    onSubmitForm () {
      this[commentsStore.actionTypes.ACTION_EDIT_COMMENT]({
        ...this.comment,
        ...this.formData
      })

      this.$modals.open({
        title: 'Updated successfully',
        body: `Comment was updated.`
      })

      setTimeout(() => {
        this.$emit('success')
      }, 3000)
    }
  }
}
</script>
